import { asArray, asDate, asNumber, asObject, asRaw, asString, asStringArray } from './guards'
import { User } from './user'

/** Port of constructors/media.js */
export class Media {
  id: number | null
  /** What the uploader called it; shown in their library. */
  name: string | null
  tags: string[] | null
  src: string | null
  owner_id: number | null
  owner: User | null
  created_at: Date | null

  constructor(data: unknown = {}) {
    const d = asRaw(data)
    this.id = asNumber(d.id)
    this.name = asString(d.name)
    this.tags = asStringArray(d.tags)
    this.src = asString(d.src)
    this.owner_id = asNumber(d.owner_id)
    this.owner = asObject(d.owner) ? new User(d.owner) : null
    this.created_at = asDate(d.created_at)
  }
}

export class SessionMedia {
  id: number | null
  tags: string[] | null
  src: string | null
  session_uuid: string | null
  created_at: Date | null
  expires_at: Date | null

  constructor(data: unknown = {}) {
    const d = asRaw(data)
    this.id = asNumber(d.id)
    this.tags = asStringArray(d.tags)
    this.src = asString(d.src)
    this.session_uuid = asString(d.session_uuid)
    this.created_at = asDate(d.created_at)
    this.expires_at = asDate(d.expires_at)
  }
}

/** A file staged for upload, before the API has assigned it an id. */
export class MediaUpload {
  name: string | null
  tags: string[] | null
  file: File | null
  file_base64: string | null

  constructor(data: unknown = {}) {
    const d = asRaw(data)
    this.name = asString(d.name)
    this.tags = asStringArray(d.tags)
    this.file = typeof File !== 'undefined' && d.file instanceof File ? d.file : null
    this.file_base64 = asString(d.file_base64)
  }
}

export function mediaListFrom(data: unknown): Media[] {
  return (asArray(data) ?? []).map((item) => new Media(item))
}
